import React from 'react';

import { PricingFeatureTable } from '@/components/wpl/pricing/src/features-table/features-table';
import { usePricingContentContext } from '@/components/wpl/pricing/src/pricing-content-context.tsx';
import { PricingFaq } from '@/components/wpl/pricing/src/pricing-faq/pricing-faq';
import { QuotationsAdornment } from '@/components/wpl/pricing/src/pricing-faq/quotations';
import { PageHeading } from '@/components/wpl/pricing/src/pricing-page-layout/page-heading';
import { PricingPageLayout } from '@/components/wpl/pricing/src/pricing-page-layout/pricing-page-layout';
import { RovoNav } from '@/templates/software/rovo/rovo-nav.tsx';
import { ParentScrollTracking } from '@/utils/scroll-tracking/parent-scroll-tracker.tsx';
import { UserLocale } from '@/utils/useGeoCurrency.ts';

import { AppPricingData } from '../../../../../../contentful/product-catalog';

import { RovoPriceFinder } from './sections/rovo-price-finder.tsx';
import { RovoQuestionsCta } from './sections/rovo-questions-cta.tsx';

export type SoftwareRovoPricingPageTemplateProps = {
	pricing?: AppPricingData;
	countryCode?: UserLocale;
};

export const SoftwareRovoPricingPageTemplate: React.FC<SoftwareRovoPricingPageTemplateProps> = (
	props,
) => {
	const content = usePricingContentContext();
	return (
		<PricingPageLayout nav={<RovoNav />} showFallback={content?.hasError}>
			<ParentScrollTracking pageId="rovo-pricing-page">
				<PageHeading>
					<span id="rovo">{content?.headline}</span>
				</PageHeading>
				<RovoPriceFinder {...props} />
				<PricingFeatureTable
					title={content?.compareFeaturesTitle ?? undefined}
					comparePlans={content?.comparePlans ?? undefined}
					compareFeatures={content?.compareFeatures ?? undefined}
				/>
				<QuotationsAdornment>
					<ParentScrollTracking>
						<PricingFaq
							header={content?.getMoreDetailsTitle ?? undefined}
							planDetails={content?.additionalDetails ?? undefined}
						/>
					</ParentScrollTracking>
				</QuotationsAdornment>
				<RovoQuestionsCta />
			</ParentScrollTracking>
		</PricingPageLayout>
	);
};
